module.exports = __webpack_public_path__ + "src/assets/games/15/10.jpg";